/** Ported from wanderu-component-chart/src/constants.js */

export const VERTICAL_OFFSET = 10
export const HORIZONTAL_OFFSET = 55
export const GRAPH_OFFSET = HORIZONTAL_OFFSET + 25

export const TOOLTIP_BORDER_RADIUS = 7
export const TOOLTIP_HEIGHT = 72
export const TOOLTIP_WIDTH = 88
export const TOOLTIP_DISTANCE = 32
export const TOOLTIP_TEXT_HEIGHT = TOOLTIP_HEIGHT / 2 - 1
export const TOOLTIP_SUB_TEXT_HEIGHT = TOOLTIP_HEIGHT * 0.75 + 1

export const POINT_RADIUS = 4
export const TEXT_VERTICAL_OFFSET = 35
export const OUTLINE_RADIUS = 10

export const MAX_COLUMN_WIDTH = 30
export const COLUMN_SCALING_FACTOR = 0.9

export const SMOOTHING_FACTOR = 0.2

/** Month abbreviations for axis labels and tooltips */
export const MONTH_ABBREVIATIONS = [
    '',
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
]

/** Colors from ui-react variables */
export const CHART_BLUE = '#00bfd5'
export const AXIS_GREY = '#d5dde6'
export const LABEL_GREY = '#707782'
export const TOOLTIP_DARK = '#414042'
